<template>
  <v-card flat tile>
    <v-card-title>Purchase Details</v-card-title>
    <v-card-text>
    <v-list dense v-if="adminAssetHistory">
      <v-list-item
        v-for="(detail, d) in detailList()"
        :key="d"
        :class="d % 2 === 0 ? 'blue lighten-5' : ''"
      >
        <v-list-item-content>
          <v-col cols="6" class="pa-0">{{ detail.text }}</v-col>
          <v-col cols="6" class="pa-0 text-right">{{ detail.value }}</v-col>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AssetHistoryDetailsList',

    computed: {
      ...mapGetters([
        'adminAssetHistory'
      ])
    },

    methods: {
      detailList: function() {
        return [
          {
            text: 'Original Price',
            value: this.$options.filters.numberToMoney(this.adminAssetHistory.originalPrice)
          },
          {
            text: 'Purchased Price',
            value: this.$options.filters.numberToMoney(this.adminAssetHistory.purchasePrice)
          },
          {
            text: 'Purchaser',
            value: this.adminAssetHistory.purchaserEmailAddress
          },
          {
            text: 'Profit',
            value: this.$options.filters.numberToMoney(this.adminAssetHistory.profit)
          },
          {
            text: 'BCC Profit',
            value: this.$options.filters.numberToMoney(this.adminAssetHistory.bccProfit)
          },
          {
            text: 'Consignor Profit',
            value: this.$options.filters.numberToMoney(this.adminAssetHistory.consignorProfit)
          },
          {
            text: 'Investor Profit',
            value: this.$options.filters.numberToMoney(this.adminAssetHistory.investorProfit)
          },
          {
            text: 'Total Shares',
            value: this.adminAssetHistory.totalShares
          },
          {
            text: 'Per Share Payback',
            value: this.$options.filters.numberToMoney(this.adminAssetHistory.investorPerSharePayback)
          },
          {
            text: 'Per Share Profit',
            value: this.$options.filters.numberToMoney(this.adminAssetHistory.investorPerShareProfit)
          },
          {
            text: 'Number of Shares Purchased',
            value: this.adminAssetHistory.numSharesPurchased
          },
          {
            text: 'Share Purchase Price',
            value: this.$options.filters.numberToMoney(this.adminAssetHistory.sharePurchasePrice)
          },
        ]
      }
    }
  }
</script>
